import { Reveal } from "./Reveal";
import { IMAGES, PORTFOLIO } from "../lib/data";

export const Portfolio = () => (
  <section id="portfolio" data-testid="portfolio-section" className="relative py-24 md:py-36 border-t border-white/5 scroll-mt-24">
    <div className="mx-auto max-w-[1400px] px-5 md:px-10">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
        <div>
          <Reveal>
            <p className="text-xs uppercase tracking-[0.3em] text-[#D4AF37] mb-5">Live Activations</p>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="font-display font-black uppercase tracking-tight text-white text-4xl md:text-6xl leading-[0.95]">
              Portfolio
            </h2>
          </Reveal>
        </div>
        <Reveal delay={0.2}>
          <p className="max-w-sm text-white/50 font-light text-sm md:text-base">
            A look at the environments Good Shot is built for — premium activations available for
            booking nationwide, right now.
          </p>
        </Reveal>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-5 md:gap-6 auto-rows-[240px] md:auto-rows-[300px]">
        {PORTFOLIO.map((p, i) => (
          <Reveal
            key={i}
            delay={0.06 * i}
            className={p.size === "lg" ? "md:col-span-2 md:row-span-1" : "md:col-span-1"}
          >
            <div
              data-testid={`portfolio-item-${i}`}
              className="relative h-full w-full overflow-hidden group border border-white/5 hover:border-[#D4AF37]/40 transition-colors duration-500"
            >
              <img
                src={IMAGES[p.image]}
                alt={p.title}
                className="w-full h-full object-cover transition-transform duration-[900ms] ease-out group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black via-black/20 to-transparent" />
              <div className="absolute bottom-0 left-0 p-6">
                <p className="text-[10px] uppercase tracking-[0.25em] text-[#D4AF37]">{p.tag}</p>
                <h3 className="mt-2 font-display font-bold uppercase tracking-wide text-white text-xl md:text-2xl">
                  {p.title}
                </h3>
              </div>
              <div className="absolute top-4 right-4 text-[9px] uppercase tracking-[0.2em] text-[#D4AF37] border border-[#D4AF37]/40 px-2 py-1">
                Available Now
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
